import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[tessDialogInsertion]',
})
export class DialogInsertionDirective {
  readonly #containerRef = inject(ViewContainerRef);

  viewContainerRef: ViewContainerRef;

  constructor() {
    this.viewContainerRef = this.#containerRef;
  }
}
